export default "__VITE_ASSET__88214ccf__"